import firebase from "firebase";

const prodconfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
};

const devconfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
};

// export const fire = firebase.initializeApp(lazyConfig);

// module.exports = fire;

export const config =
  process.env.NODE_ENV === "production" ? prodconfig : devconfig;

export const fire = firebase.initializeApp(config);

export const auth = firebase.auth();
export const db = firebase.database();
export const dbRef = firebase.database().ref();

// Signing Up
// If need to change the API key for the firebase, Please go to the .env file to change it
export const doCreateUserWithEmailPassword = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

// Signing in via facebook
export const facebookProvider = new firebase.auth.FacebookAuthProvider();

// Signing in via email and password
export const doSigninWithEmailPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

// Signing out
export const doSignout = () => auth.signOut();

// Getting the Lock List
export const doGetLocklist = () => "userLocks/" + auth.currentUser.uid;

// Getting the Individual Lock
export const doGetSelectedLock = (selectedLock) =>
  "userLocks/" + selectedLock + auth.currentUser.uid;

// Getting the User Friend List
export const doGetUserlist = () => "userFriendList/" + auth.currentUser.uid;

export const doGetAccess = () =>
  "retractableSharingRegistry/" + auth.currentUser.uid;

export const getUserIdFromEmail = (email) =>
  db.ref("egeetouch-d0086/registeredUsersOnPlatform");

// Getting the MyShareHistory List
export const doGetMyshareHistorylist = () =>
  "MyShareHistory/" + auth.currentUser.uid;

// Getting the Audit Trail List
export const doGetAuditTrailList = () => "AuditTrail";

// Getting the Audit Locks List
export const doGetAdminLockslList = () =>
  "MyAdminLocks/" + auth.currentUser.uid;

export default firebase;
